module.exports = __webpack_public_path__ + "img/man-sm.974570b9.svg";